/**
 * BNAR: lista fixa de ícones pré-definidos para a "Imagem do Canal" das
 * caixas de entrada, no lugar do upload de imagem livre.
 *
 * A `key` é o valor persistido em `inbox.custom_channel_icon` (coluna
 * `inboxes.custom_channel_icon`, ver migration 20260720120000 e
 * `Inbox::CUSTOM_CHANNEL_ICONS` no backend — as duas listas precisam ficar
 * em sincronia).
 *
 * `icon` é a versão monocromática (usada onde só cabe glifo, ex: filtros) e
 * `brandIcon` a versão colorida com a cor oficial da marca — usada no seletor
 * e na barra lateral. As classes são as mesmas já usadas em
 * components-next/icon/provider.js (coleções `woot`/`logos`/`lucide`
 * registradas em tailwind.config.js — nenhum asset novo é necessário).
 * Sem `brandIcon` (e-mail genérico, chat) cai no glifo monocromático.
 */
export const CHANNEL_ICON_OPTIONS = [
  {
    key: 'whatsapp',
    labelKey: 'WHATSAPP',
    icon: 'i-woot-whatsapp',
    brandIcon: 'i-logos-whatsapp-icon',
  },
  {
    key: 'instagram',
    labelKey: 'INSTAGRAM',
    icon: 'i-woot-instagram',
    brandIcon: 'i-woot-instagram-color',
  },
  {
    key: 'messenger',
    labelKey: 'MESSENGER',
    icon: 'i-woot-messenger',
    brandIcon: 'i-logos-messenger',
  },
  {
    key: 'gmail',
    labelKey: 'GMAIL',
    icon: 'i-woot-gmail',
    brandIcon: 'i-logos-google-gmail',
  },
  {
    key: 'outlook',
    labelKey: 'OUTLOOK',
    icon: 'i-woot-outlook',
    brandIcon: 'i-woot-outlook-color',
  },
  {
    key: 'telegram',
    labelKey: 'TELEGRAM',
    icon: 'i-woot-telegram',
    brandIcon: 'i-logos-telegram',
  },
  {
    key: 'tiktok',
    labelKey: 'TIKTOK',
    icon: 'i-woot-tiktok',
    brandIcon: 'i-logos-tiktok-icon',
  },
  {
    key: 'line',
    labelKey: 'LINE',
    icon: 'i-woot-line',
    brandIcon: 'i-woot-line-color',
  },
  // Sem logo de marca (são tipos de canal, não marcas) — glifo neutro, o
  // mesmo da tela de "Adicionar caixa de entrada". Os dois de voz são os
  // selos com a onda de áudio (Twilio Voice e Chamada do WhatsApp).
  { key: 'website', labelKey: 'WEBSITE', icon: 'i-woot-website' },
  { key: 'sms', labelKey: 'SMS', icon: 'i-woot-sms' },
  { key: 'api', labelKey: 'API', icon: 'i-woot-api' },
  { key: 'voice_call', labelKey: 'VOICE_CALL', icon: 'i-woot-voice-call' },
  {
    key: 'whatsapp_voice',
    labelKey: 'WHATSAPP_VOICE',
    icon: 'i-woot-whatsapp-voice',
  },
  { key: 'mail', labelKey: 'GENERIC_EMAIL', icon: 'i-woot-mail' },
  { key: 'chat', labelKey: 'CHAT', icon: 'i-lucide-message-circle' },
];

export const CHANNEL_ICON_MAP = CHANNEL_ICON_OPTIONS.reduce((map, option) => {
  map[option.key] = option.icon;
  return map;
}, {});

export const CHANNEL_BRAND_ICON_MAP = CHANNEL_ICON_OPTIONS.reduce(
  (map, option) => {
    if (option.brandIcon) map[option.key] = option.brandIcon;
    return map;
  },
  {}
);

export const getCustomChannelIconClass = key => CHANNEL_ICON_MAP[key] || null;

// Versão colorida (cor oficial da marca) — null quando não existe.
export const getCustomChannelBrandIconClass = key =>
  CHANNEL_BRAND_ICON_MAP[key] || null;
